export default __webpack_public_path__ + "static/media/01.278a9320.webp";